import { Component, Input, ViewEncapsulation } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  standalone: true,
  selector: 'email-new-badge',
  styleUrls: ['./email-new-badge.component.less'],
  template: ` <div class="new-badge-outer">
    <table class="new-badge" cellpadding="0" cellspacing="0">
      <tr>
        <td class="new-badge-content">
          <email-text [className]="'new-badge-text'" [contents]="label" />
        </td>
      </tr>
    </table>
  </div>`,
  imports: [EmailTextComponent],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EmailNewBadgeComponent {
  @Input() public label: WrappedValue<string>;
}
